module.exports = __webpack_public_path__ + "img/showBanner.93b0901d.png";